import Resource from '@/api/core/resource'

class Usuario extends Resource {
  constructor () {
    super('administracion/usuarios')
  }

  obtenerPermisos (id) {
    return this.request.get(this.uri.concat('/permisos/').concat(id))
  }

  guardarPermisos (data) {
    return this.request.put(this.uri.concat('/permisos/').concat(data.id), {
      permisos: data.permisos_seleccionados
    })
  }
}

export default new Usuario()
